// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import {Loading} from 'element-ui'
import Axios from 'axios'
import qs from 'qs'
import VueAxios from 'vue-axios'
import loki from 'lokijs'
import * as rrweb from 'rrweb'
import App from './App'
import router from './router'
import $$ from './tool/BaseXJT.js'
import ls from './tool/sessionStorage.js'
import UrlConfig from './tool/UrlConfig.js'

// 导入jquery和bootstrap
import 'jquery/dist/jquery.min'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'element-ui/lib/theme-chalk/index.css'

/* 导入公共css和js */
import '../static/css/reset.css'
import baseUrl from './tool/baseUrl'

Vue.prototype.ls = ls;
Vue.prototype.loki = loki;
Vue.prototype.rrweb = rrweb;
Vue.prototype.Loading = Loading;
Vue.prototype.qs = qs;
Vue.prototype.$$ = $$;
Vue.prototype.UrlConfig = UrlConfig;
Vue.config.productionTip = false;
Vue.use(VueAxios, Axios);
Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
  //配置接口信息
  Axios.defaults.baseURL = baseUrl.rootUrl;

  next();

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js